import React, { useState } from "react";
import "./style.css";
import SVGCrossIcon from "../../../svg/SVGCrossIcon";

const Index = (props) => {
  const { setIsCancelPopup, showCancelButton } = props;
  const [effect, setEffect] = useState("cancel-modal");

  const closeCancelPaymentModal = () => {
    setEffect("cancel-modal-opened");
    setTimeout(() => {
      setIsCancelPopup(false);
      setEffect("cancel-modal");
    }, 250);
  };

  return (
    <React.Fragment>
      <div className="offerPopupSection cancelTransaction">
        <div className={effect}>
          {showCancelButton && (
            <button
              onClick={closeCancelPaymentModal}
              type="button"
              className="btn-close"
              aria-label="Close"
            >
              <SVGCrossIcon/>
            </button>
          )}
          {props?.children}
        </div>
      </div>
    </React.Fragment>
  );
};

export default Index;
